import { type FC } from 'react';
import { type SwitchPropsTypes } from '../types/SwitchProps';
import styles from './Switch.module.scss';

const Swicth: FC<SwitchPropsTypes> = ({
  text,
  isActive,
  disabled,
  overlayCheckOnCircle,
  ...restProps
}: SwitchPropsTypes) => (
  <label role="presentation" className={`${styles['switch']} ${overlayCheckOnCircle ? styles['switchWithTick'] : ''}`}>
    <input
      type="checkbox"
      checked={disabled ? false : isActive}
      name={text}
      id={text}
      disabled={disabled}
      data-testid="switch-test-id"
      {...restProps}
    />
    <span className={`${styles['slider']} ${styles['round']}`}></span>
    <span className={`${styles['checkmark']} ${overlayCheckOnCircle ? styles['checkmarkWithTick'] : ''}`}></span>
    {text && <span className={styles['text']}>{text}</span>}
  </label>
);

export default Swicth;
